import { useEffect, useState } from "react";

export default function useCurrencyRate() {

  const [usdRate, setUsdRate] = useState(25500);
  const [timeLastUpdated, setTimeLastUpdated] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {

    const fetchExchangeRate = async () => {

      const lastFetchDate = localStorage.getItem("usd_rate_date");
      const today = new Date().toDateString();

      // Nếu hôm nay fetch rồi thì lấy cache
      if (lastFetchDate === today) {

        const cachedRate = localStorage.getItem("usd_rate");
        const cachedUpdatedTime = localStorage.getItem("usd_rate_updated");

        if (cachedRate) {
          setUsdRate(Number(cachedRate));
        }

        if (cachedUpdatedTime) {
          setTimeLastUpdated(cachedUpdatedTime);
        }

        return;
      }

      setLoading(true);

      try {

        const res = await fetch(
          "https://open.er-api.com/v6/latest/USD"
        );

        const data = await res.json();

        setUsdRate(data.rates.VND);
        setTimeLastUpdated(data.time_last_update_utc);

        // Save cache
        localStorage.setItem("usd_rate", data.rates.VND);
        localStorage.setItem(
          "usd_rate_updated",
          data.time_last_update_utc
        );

        localStorage.setItem(
          "usd_rate_date",
          today
        );

      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchExchangeRate();

  }, []);

  return {
    usdRate,
    timeLastUpdated,
    loading
  };
}